const RELEASE_NOTE_COMPONENTS = {
  TEMPLATE: 'Template',
  BACKEND: 'Backend',
  IOS: 'iOS',
};

export default RELEASE_NOTE_COMPONENTS;
